import { lazy } from "react";
import * as routes from "./routes";
import { ROLES } from "./roleConstants.js";

const ROUTE_SOURCES = [
  {
    path: routes.BASE_PATH_PREFIX,
    component: lazy(() => import("../modules/home/view/Home")),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.PROVIDER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
      ROLES.SUPER_ADMIN,
    ],
  },
  {
    path: routes.LOGIN_PATH,
    component: lazy(() => import("../modules/login/view/Login")),
    isPublic: true,
    isLoginPage: true,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.TENANT_ADMIN,
      ROLES.SUPER_ADMIN,
    ],
  },
  {
    path: routes.NOACCESS,
    component: lazy(() => import("../modules/login/view/NoAccess")),
    // isPublic: true,
    roles: [...Object.values(ROLES)],
  },
  {
    path: routes.UNAUTHORIZED,
    component: lazy(() => import("../modules/login/view/Unauthorized")),
    isShowSidebar: false,
    roles: [...Object.values(ROLES)],
  },
  {
    path: routes.NOT_CONNECTED,
    component: lazy(() => import("../modules/login/view/NotConnected")),
    isPublic: true,
    roles: [...Object.values(ROLES)],
  },
  {
    path: routes.TENANT_MANAGEMENT,
    component: lazy(
      () => import("../modules/tenantManagement/view/TenantManagement"),
    ),
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.TENANT_DETAILS,
    component: lazy(
      () => import("../modules/tenantManagement/view/TenantDetails"),
    ),
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.TENANT_HIERARCHY_CONFIGURATION,
    component: lazy(
      () => import("../modules/tenantHierarchyConfiguration/view/TenantHierarchyConfiguration"),
    ),
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.MASTER_TIMEZONE_MANAGEMENT,
    component: lazy(
      () => import("../modules/timeZoneMaster/view/TimeZoneMaster"),
    ),
    roles: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.LIVE_AVAILABLE_SHIFTS,
    component: lazy(
      () => import("../modules/liveAvailableShifts/view/LiveAvailableShifts"),
    ),
    roles: [ROLES.PROVIDER, ROLES.STAKE_HOLDERS],
  },
  {
    path: routes.RAD_LIST,
    component: lazy(() => import("../modules/rad/radList/view/RadList")),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.UNASSIGNED_PROVIDER_LIST,
    component: lazy(
      () =>
        import("../modules/rad/unassignedProviderList/view/UnassignedProviderList"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.STATE_LICENSE,
    component: lazy(
      () => import("../modules/rad/stateLicense/view/StateLicense"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.LICENSE_PRIVILEGE_POWER_SYNC,
    component: lazy(
      () => import("../modules/rad/licensePrivilegesPowerSync/view/LicensePrivilegesPowerSync"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.RAD_PROFILE,
    component: lazy(() => import("../modules/rad/radProfile/view/radProfile")),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.PROVIDER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.CAPACITY_INPUT,
    component: lazy(
      () => import("../modules/rad/capacityInput/view/RadCapacityInput"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.CAPACITY_INPUT_NEW,
    component: lazy(
      () =>
        import("../modules/rad/capacityInputNew/view/ProviderCapacityInput"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.CUSTOM_VIEW,
    component: lazy(() => import("../modules/rad/customView/view/CustomView")),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.RAD_CUSTOM_VIEW,
    component: lazy(
      () => import("../modules/rad/customView/view/RadCustomView"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.CONFIG_CUSTOM_VIEW,
    component: lazy(
      () => import("../modules/rad/customView/view/ConfigCustomView"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.CONFIG_CUSTOM_VIEW_EDIT,
    component: lazy(
      () => import("../modules/rad/customView/view/ConfigCustomView"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.RAD_LEADERSHIP_BULK_UPDATE,
    component: lazy(
      () =>
        import("../modules/rad/leadershipBulkUpdate/view/RadLeadershipBulkUpdate"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RAD_HOURLY_VOLUME_SHARE,
    component: lazy(
      () =>
        import("../modules/rad/hourlyVolumeShare/view/RadHourlyVolumeShare"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.ANNUAL_HOUR_TRACKER,
    component: lazy(
      () =>
        import("../modules/rad/annualHourTracker/view/RadAnnualHourTracker"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.AUDIT_LOGS,
    component: lazy(() => import("../modules/rad/auditLogs/view/RadAuditLogs")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.MAIN_PRACTICE,
    component: lazy(
      () => import("../modules/admin/mainpractice/view/MainPractice.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.NATIONAL,
    component: lazy(() => import("../modules/admin/national/view/National")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.REGION,
    component: lazy(() => import("../modules/admin/region/view/Region")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.REGIONALPRACTICEWORKLIST,
    component: lazy(
      () =>
        import("../modules/admin/regionalPracticeWorklist/view/RegionalPracticeWorklist"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.REGIONALPRACTICE,
    component: lazy(
      () =>
        import("../modules/admin/regionalPractice/view/RegionalPractice.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RPCE,
    component: lazy(() => import("../modules/admin/rpce/view/RPCE")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.WORKLIST,
    component: lazy(() => import("../modules/admin/worklist/view/Worklist")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SUBPRACTICE,
    component: lazy(
      () => import("../modules/admin/subpractice/view/Subpractice"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.WORKLIST_DEFINITION,
    component: lazy(
      () => import("../modules/admin/worklistDefinition/view/WorklistDefinition"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.WORKLIST_GROUP,
    component: lazy(
      () => import("../modules/admin/worklistGroup/view/WorklistGroup"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TAG_CATEGORY_CONFIGURATION,
    component: lazy(
      () => import("../modules/admin/tagCategoryConfiguration/view/TagCategoryConfiguration"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.WORKLIST_DEFINITION_CONFIGURATION,
    component: lazy(
      () => import("../modules/admin/worklistDefinitionConfiguration/view/WorklistDefinitionConfiguration"),
    ),
    roles: [ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PRACTICE,
    component: lazy(() => import("../modules/admin/practice/view/Practice")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SECTIONWORKLIST,
    component: lazy(
      () =>
        import("../modules/admin/SectionWorklistMapping/view/SectionWorklist"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SUBSPECIALITY,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/subspeciality/view/Subspeciality"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PROVIDER_DOCUMENT_TYPE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/provider-document-type/view/ProviderDocumentType"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PROVIDER_NOTE_TYPE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/provider-note-type/view/ProviderNoteType"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.WEEK_ROTATION,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/weekRotation/view/WeekRotation"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.WEEK_ROTATION_TEMPLATE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/weekRotationTemplate/view/WeekRotationTemplate"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PARTNERSHIP_RATE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/partnershipRate/view/PartnershipRate"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PARTNERSHIP_STATUS,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/partnershipStatus/view/PartnershipStatus"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PARTNERSHIP_TIME,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/partnershipTime/view/PartnershipTime"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RAD_TYPE,
    component: lazy(
      () => import("../modules/admin/dropdownManagement/radtype/view/RadType"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RAD_STATUS,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/radstatus/view/RadStatus"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RAD_DEGREE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/radDegree/view/RadDegree"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.COMMITTEES,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/committees/view/Committees"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FUTURE_SECTION_CHANGE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/futureSectionChange/view/FutureSectionChange"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.USERMANAGEMENT,
    component: lazy(
      () => import("../modules/admin/UserManagement/view/UserManagement"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.TENANT_ADMIN,
      ROLES.SUPER_ADMIN,
    ],
  },
  {
    path: routes.TRAUMA_FACILITY_LEVEL,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/Trauma Facility Level/view/TraumaFacilityLevel"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SCHEDULETYPE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/scheduletype/view/ScheduleType"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RAD_COMMUNICATION_TYPE,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/radCommunicationType/view/radCommunicationType"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RVURATE,
    component: lazy(
      () => import("../modules/admin/dropdownManagement/rvurate/view/rvurate"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TIMEZONE_MANAGEMENT,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/timezonemanagement/view/Timezone"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SITECOVERAGEMATRIX,
    component: lazy(
      () =>
        import("../modules/admin/configuration/siteCoverageMatrix/view/SiteCoverageMatrix"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.REQUEST_STATUS,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/requeststatus/view/requeststatus"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.QGENDA_SECTION,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/qgendaSection/view/QgendaSection"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SITE_STATUS,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/siteStatus/view/siteStatus"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.MODALITY,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/modality/view/Modality"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PRIORITY,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/priority/view/Priority"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.STAFF_CATEGORY,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/staffCategory/view/StaffCategory"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.STAFF_PRIMARY_LOCATION,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/staffPrimaryLocation/view/StaffPrimaryLocation"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SPECIALTY_CASES,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/specialtyCases/view/SpecialtyCases"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.STAFFING_AGENCY,
    component: lazy(
      () =>
        import("../modules/admin/dropdownManagement/staffingAgency/view/StaffingAgency"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.COVERAGE_GAP,
    component: lazy(
      () =>
        import("../modules/admin/configuration/coverageGapColor/view/coverageGapColor"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PRIORITYSLAMAPPING,
    component: lazy(
      () =>
        import("../modules/admin/configuration/PrioritySLAMapping/view/PrioritySLAMapping"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SHIFT_HOUR_CONFIGURATION,
    component: lazy(
      () =>
        import("../modules/admin/configuration/ShiftHourConfiguration/view/ShiftHourConfiguration"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.DLS_CONFIGURATION,
    component: lazy(
      () =>
        import("../modules/admin/configuration/dlsConfiguration/view/DLSConfiguration"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.BLOCK_PLANNING,
    component: lazy(
      () =>
        import("../modules/admin/configuration/blockPlanningColorConfiguration/view/blockPlanningColorConfiguration"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.DAY_OF_WEEK_CONFIGURATION,
    component: lazy(
      () =>
        import("../modules/admin/configuration/DayOfWeekConfiguration/view/DayOfWeekConfig"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TASK_CONFIGURATION,
    component: lazy(
      () =>
        import("../modules/admin/configuration/taskconfiguration/view/taskconfiguration"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TASK_CONFIGURATION_PANEL_BASE,
    component: lazy(
      () =>
        import("../modules/admin/configuration/taskconfiguration/view/TaskConfigurationPanelRedirect"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TASK_CONFIGURATION_PANEL_GENERAL,
    component: lazy(
      () =>
        import("../modules/admin/configuration/taskconfiguration/view/TaskConfigurationGeneralPage"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TASK_CONFIGURATION_PANEL_TASK_TAGS,
    component: lazy(
      () =>
        import("../modules/admin/configuration/taskconfiguration/view/TaskConfigurationTaskTagsPage"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TASK_CONFIGURATION_PANEL_PROVIDER_POOL,
    component: lazy(
      () =>
        import("../modules/admin/configuration/taskconfiguration/view/TaskConfigurationProviderPoolPage"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TASK_CONFIGURATION_PANEL_COMPENSATION,
    component: lazy(
      () =>
        import("../modules/admin/configuration/taskconfiguration/view/TaskConfigurationCompensationPage"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PROVIDER_TASK_POOL,
    component: lazy(
      () =>
        import("../modules/admin/configuration/providerTaskPool/view/ProviderTaskPool"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SIMULATOR_COLOR_CONFIGURATION,
    component: lazy(
      () =>
        import("../modules/admin/configuration/simulatorColorConfiguration/view/simulatorColorConfiguration"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.LICENSE_PRIVILEGE_STATUS_MAPPING,
    component: lazy(
      () =>
        import("../modules/admin/configuration/licensePrivilegeStatusMapping/view/LicensePrivilegeStatusMappingRedirect"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.LICENSE_MAPPING,
    component: lazy(
      () =>
        import("../modules/admin/configuration/licensePrivilegeStatusMapping/view/LicenseMapping"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PRIVILEGES_MAPPING,
    component: lazy(
      () =>
        import("../modules/admin/configuration/licensePrivilegeStatusMapping/view/PrivilegesMapping"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.READING_STATUS_MAPPING,
    component: lazy(
      () =>
        import("../modules/admin/configuration/licensePrivilegeStatusMapping/view/ReadingStatusMapping"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.DEFINE_MISMATCH,
    component: lazy(
      () =>
        import("../modules/admin/configuration/licensePrivilegeStatusMapping/view/DefineMismatch"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.HOLIDAYPLANNER,
    component: lazy(
      () => import("../modules/admin/holidayPlanner/view/HolidayPlanner"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: `${routes.ADMIN_PATH}/holiday-demand-planner/:id`,
    component: lazy(
      () =>
        import("../modules/admin/holidayDemandPlanner/view/holidayDemandPlanner"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.RAW_EXAM_DATA,
    component: lazy(
      () => import("../modules/exam/rawExamData/view/RawExamData"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.TAT_DATA,
    component: lazy(() => import("../modules/exam/TAT/view/TATData")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.UNREAD,
    component: lazy(() => import("../modules/exam/Unread/view/Unread")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.EXAM_DATA,
    component: lazy(() => import("../modules/exam/examData/view/ExamData")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.EXAM_METRICS,
    component: lazy(
      () => import("../modules/exam/examMetrics/view/ExamMetrics"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.EDIT_RAD_PROFILE,
    component: lazy(
      () =>
        import("../modules/rad/editRadProfileDuplicate/view/editRadProfileDuplicate"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.MISCELLANEOUS_SITE_DATA,
    component: lazy(
      () =>
        import("../modules/exam/miscellaneousSiteData/view/MiscellaneousSiteData"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SITE_LIST,
    component: lazy(() => import("../modules/site/siteList/view/SiteList")),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.EDIT_SITE_PROFILE,
    component: lazy(
      () => import("../modules/site/editSiteProfile/view/editSiteProfile"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.EXAM_DATA_READ,
    component: lazy(() => import("../modules/exam/read/view/read")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.UNASSIGNED_SITES,
    component: lazy(
      () =>
        import("../modules/site/unassignedSiteList/view/UnassignedSiteList"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SITEALIASMANAGEMENT_SITE,
    component: lazy(
      () =>
        import("../modules/site/sitealiasmanagement/view/SiteAliasManagement.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SITE_HOURLY_VOLUME_SHARE,
    component: lazy(
      () =>
        import("../modules/site/hourlyVolumeShare/view/SiteHourlyVolumeShare"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.REPORT_CONFIGURATION,
    component: lazy(
      () =>
        import("../modules/reports/reportConfiguration/view/ReportConfiguration"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.MATRIX_DAILY_REPORT,
    component: lazy(
      () =>
        import("../modules/reports/matrixDailyReport/view/MatrixDailyReport"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.PERFORMANCE_DASHBOARD,
    component: lazy(
      () =>
        import("../modules/reports/performanceDashboard/view/PerformanceDashboard"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.COVERAGE_GAP_TOOL,
    component: lazy(
      () => import("../modules/reports/coverageGapTool/view/CoverageGapTool"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.PRIVILEGE_POWER_SYNC,
    component: lazy(
      () =>
        import("../modules/reports/privilegePowerSync/view/PrivilegePowerSync"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.HOLIDAY_GAP_TOOL,
    component: lazy(
      () => import("../modules/reports/holidayGapTool/view/HolidayGapTool"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: `${routes.SITE_PROFILE}/:id`,
    component: lazy(
      () => import("../modules/site/siteProfile/view/siteProfile"),
    ),
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
  },
  {
    path: routes.MATRIX_SERVICE_REQUEST,
    component: lazy(
      () =>
        import("../modules/StrategicForecast/matrixservicerequest/view/MatrixServiceRequest.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.STRATEGIC_DEMAND_PLANNER,
    component: lazy(
      () =>
        import("../modules/StrategicForecast/strategicdemandplanner/view/strategicdemandplanner.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.STRATEGIC_CAPACITY_PLANNER,
    component: lazy(
      () =>
        import("../modules/StrategicForecast/strategiccapacityplanner/view/strategiccapacityplanner.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.STRATEGIC_CAPS_VS_DEMAND_PLANNER,
    component: lazy(
      () =>
        import("../modules/StrategicForecast/strategicCapsVsDemPlanner/view/strategicCapsVsDemand.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.DEMAND_TABLE,
    component: lazy(() => import("../modules/demandTable/view/DemandTable")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SCHEDULE_PATH,
    component: lazy(() => import("../modules/schedule/view/Schedule")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.VOLUME_TREND_REPORT,
    component: lazy(
      () => import("../modules/volumeTrendReport/view/volumeTrendReport"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.CAPACITY_TABLE,
    component: lazy(
      () => import("../modules/capacityTable/view/CapacityTable"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.CAPS_VS_DEMAND_TABLE,
    component: lazy(
      () => import("../modules/capacityVsdemnadTable/view/CapsVsDemandTable"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FORECAST,
    component: lazy(
      () => import("../modules/demandForecast/forecasting/view/Forecast"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FORECAST_OPTIMIZE,
    component: lazy(
      () =>
        import("../modules/demandForecast/capacityForecast/view/CapacityForecast"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FORECAST_CAPSVSDEMAND,
    component: lazy(
      () => import("../modules/demandForecast/capsVsDemand/view/CapsVsDemand"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FORECASTREPORT,
    component: lazy(
      () => import("../modules/demandForecast/report/view/ForecastReport.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  // New Forecast 2.0 routes
  {
    // path: routes.FORECAST2,
    // component: lazy(() => import('../modules/demandForecast2/forecasting/view/Forecast')),
    // roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN]
  },
  {
    path: routes.FORECASTREPORT2,
    component: lazy(
      () => import("../modules/demandForecast2/report/view/ForecastReport.jsx"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },

  {
    path: routes.OPTIMIZE,
    component: lazy(() => import("../modules/optimize/view/Optimize")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SCHEDULE,
    component: lazy(() => import("../modules/scheduling/view/Scheduling.jsx")),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FORECASTING_FORECAST,
    component: lazy(
      () => import("../modules/forecasting/forecast/view/ForecastingForecast"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.GENERATE_FORECAST,
    component: lazy(
      () =>
        import("../modules/forecasting/generateForecast/view/GenerateForecast"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FORECASTING_OPTIMIZE,
    component: lazy(
      () => import("../modules/forecasting/optimize/view/ForecastingOptimize"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.DEMAND_FORECAST,
    component: lazy(
      () => import("../modules/forecasting/demandForecast/view/DemandForecast"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.FORECASTING_SCHEDULES,
    component: lazy(
      () =>
        import("../modules/forecasting/schedules/view/ForecastingSchedules"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.CAPACITY_FORECAST,
    component: lazy(
      () =>
        import("../modules/forecasting/capacityForecast/view/CapacityForecast"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.SCHEDULE_SHARE_LINKS,
    component: lazy(
      () => import("../modules/schedule/shareLinks/view/ShareLinks"),
    ),
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    path: routes.PUBLIC_SCHEDULE,
    component: lazy(
      () => import("../modules/schedule/publicView/view/PublicSchedule"),
    ),
    isPublic: true,
    allowAuthenticated: true,
    isShowSidebar: false,
    roles: [...Object.values(ROLES)],
  },
];

export default ROUTE_SOURCES;
